import { IVatPartnerValueRequest } from '../interfaces/IVatPartnerValueRequest';

export const vatPartnerValueRequest: IVatPartnerValueRequest = {
	materialCode: '',
	salesOrganization: '',
	portOfLoadingCountry: '',
	portOfLoadingCity: '',
	portOfLoadingSite: '',
	portOfDischargeCountry: '',
	portOfDischargeCity: '',
	portOfDischargeSite: '',
	customerFactCode: '',
};